import { render, staticRenderFns } from "./PerfilChange.vue?vue&type=template&id=0e433dfc"
import script from "./PerfilChange.vue?vue&type=script&lang=js"
export * from "./PerfilChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports